import React, { Component } from 'react';
import {ShowIf} from 'components/utils';
import * as CONFIG from 'constants/config';
import {getPrice} from 'lib/convert';

export default class ProductItem extends Component {
  // deprecated
  getPrice(value) {
    String.prototype.splice = function(idx, rem, str) {
      return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
    };
    let result = value;
    if(String(result).length < 3) {
      return result
    } else {
      for (let j = Number(String(result).length); j > 0;) {
        j = j - 3;
        if(j > 0) {
          result = String(result).splice(j, 0, ",");
        }
      }
      return result
    }
  }
  render() {
    let Product = this.props.product || {}
    let style = {
      width: `${Product.averageRatingPoint && Product.averageRatingPoint.toFixed(1) * 20 || 0}%`,
      background: `#ffcc01`
    }
    return (
      <div className='wrap-tiem'>
        <div className='item-product'>
          <div className='wrap-image'>
            <img src={`${CONFIG.API_URL}/containers/products/download/${Product.images.length > 0 ? Product.images[Product.images.length - 1] : ''}`} alt='Image product'/>
          </div>
          <h4 className='product-name'>{Product.name || ''}</h4>
          <ShowIf condition={parseFloat(Product.promotionalPrice) > 0}>
            <p className='product-price'>Giá: {getPrice(Product.promotionalPrice || '0')}</p>
          </ShowIf>
          <ShowIf condition={isNaN(parseFloat(Product.promotionalPrice))}>
            <p className='product-price'>Giá: Giá tham khảo</p>
          </ShowIf>
          <ShowIf condition={parseFloat(Product.price) > 0 && Product.promotionalPrice}>
            <p className='product-old-price'>{getPrice(Product.price)}</p>
          </ShowIf>
          <ShowIf condition={this.props.type === 'topOrder'}>
            <p>Số lượt đặt hàng: {Product.totalOrderTimes || '0'}</p>
          </ShowIf>
          <ShowIf condition={this.props.type === 'topRating'}>
            <div className='product-rating'>
              <div className='rating-item'>
                <div className='rating-value' style={style}></div>
                <img src={require('assets/images/rating.png')} alt='rating'/>
              </div>
              <div className='rating-total'>({Product.totalRatingTimes && Product.totalRatingTimes || 0})</div>
            </div>
          </ShowIf>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/fair/ProductItem.jsx